module.exports = new __parcel__URL__("ai-chat-loading-promoted.9a9a0213.svg").toString();